var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20,0H5c-1.654,0-3,1.346-3,3v18c0,1.654,1.346,3,3,3h17V2c0-1.103-.897-2-2-2ZM5,2h15v16H5c-.352,0-.686.072-1,.184V3c0-.552.449-1,1-1Zm0,20c-.551,0-1-.448-1-1s.449-1,1-1h15v2H5Zm3-11.171v4.171h8v-4.171c1.164-.413,2-1.525,2-2.829,0-1.654-1.346-3-3-3-.488,0-.965.124-1.395.357-1.009-.471-2.202-.471-3.211,0-.429-.233-.907-.357-1.395-.357-1.654,0-3,1.346-3,3,0,1.304.836,2.416,2,2.829Zm1-3.829c.302,0,.526.149.661.274l.599.557.665-.476c.649-.465,1.503-.465,2.152,0l.665.476.599-.557c.134-.125.358-.274.661-.274.551,0,1,.448,1,1s-.449,1-1,1h-1v4h-4v-4h-1c-.551,0-1-.448-1-1s.449-1,1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormula);
export default __webpack_public_path__ + "static/media/formula.1ed729ee9840d6eb143424e0c7a7d338.svg";
export { ForwardRef as ReactComponent };